import * as R from 'ramda';
import * as PartnerActionTypes from '../../constants/actiontypes/partner/partner';
import * as BackofficeActionTypes from '../../constants/actiontypes/backoffice/user';
import * as PartnerLoadings from '../../constants/loadings/partner/partner';
import Partner from '../../constants/models/backoffice/partner';
import * as ActionTypesUser from '../../constants/actiontypes/backoffice/user';

import * as ActionTypesAuth from '../../constants/actiontypes/auth';
import * as ActionTypesClient from '../../constants/actiontypes/backoffice/clients';
import * as LoadingsUser from '../../constants/loadings/user';
import { toast } from 'react-toastify';
import toastConf from '../../utils/toasterConfiguration';
import * as TextClient from '../../constants/toasterText/backofficeClients';
import * as TextUser from '../../constants/toasterText/user';
import BackofficeUser from '../../constants/models/backofficeUser';

let initialState = {
    isLoading: [],
    partner: undefined,
    etablissement: undefined,
    etablissementList: {items: [], pagination: undefined},
    users: [],
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
    allDossiers: { anticipa: undefined, facilita: undefined, serenita: undefined, totalAnticipa: 0, totalFacilita: 0, totalSerenita: 0 }
};

const PartnerReducer = (state = initialState, action) => {
    switch (action.type) {

        case PartnerActionTypes.FETCH_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_PARTNER)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_PARTNER);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_PARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_PARTNER);
            state.partner = new Partner(action.data);
            return { ...state };


        case PartnerActionTypes.FETCH_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_PARTNER);
            return { ...state };


        case PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_ETABLISSEMENT_LIST);
            }
            return { ...state };       
            
        case PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT_LIST);
            state.etablissementList.items = action.data.items;
            state.etablissementList.pagination = {
                totalPages: action.data.totalPages,
                totalRecords: action.data.totalRecords,
                currentPage: action.data.pageNumber + 1,
            };
            return { ...state };

        case PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT_LIST);
            return { ...state };            

        case PartnerActionTypes.FETCH_ETABLISSEMENT_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_ETABLISSEMENT);
            }
            return { ...state };       
            
        case PartnerActionTypes.FETCH_ETABLISSEMENT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT);
            state.etablissement = action.data;
            return { ...state };

        case PartnerActionTypes.FETCH_ETABLISSEMENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT);
            return { ...state };

        case PartnerActionTypes.FETCH_USERS_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_USERS)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_USERS);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_USERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_USERS);
            state.users = action.data.items.map(u => new BackofficeUser(u));
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };

        case PartnerActionTypes.FETCH_USERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_USERS);
            return { ...state };

        case PartnerActionTypes.FETCH_ANTICIPA_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_ANTICIPA)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_ANTICIPA);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_ANTICIPA_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ANTICIPA);
            let anticpa = action.data.items.map(u => new BackofficeUser(u));

            return { ...state, allDossiers: { ...state.allDossiers, anticipa: anticpa, totalAnticipa: action.data.totalRecords } };


        case PartnerActionTypes.FETCH_ANTICIPA_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ANTICIPA);
            return { ...state };

        
        case PartnerActionTypes.FETCH_SERENITA_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_SERENITA)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_SERENITA);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_SERENITA_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_SERENITA);
            let serenita = action.data.items.map(u => new BackofficeUser(u));
            return { ...state, allDossiers: { ...state.allDossiers, serenita: serenita, totalSerenita: action.data.totalRecords } };


        case PartnerActionTypes.FETCH_SERENITA_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_SERENITA);
            return { ...state };
        

        case BackofficeActionTypes.DELETE_BACKOFFICE_USER_REQUEST:
            // if (!state.isLoading.includes(PartnerLoadings.FETCHING_ANTICIPA)) {
            //     state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_ANTICIPA);
            // }
            return { ...state };

        case BackofficeActionTypes.DELETE_BACKOFFICE_USER_SUCCESS:
            state.users = state.users.filter(user => user.id !== action.userId);
            let allAnticipa = state.allDossiers.anticipa.filter(user => user.id !== action.userId);
            let totalAnticipa = state.allDossiers.totalAnticipa - 1;

            return { ...state, allDossiers: { ...state.allDossiers, anticipa: allAnticipa, totalAnticipa: totalAnticipa } };


        case BackofficeActionTypes.DELETE_BACKOFFICE_USER_FAILURE:
            return { ...state };

        case PartnerActionTypes.FETCH_FACILITA_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_FACILITA)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_FACILITA);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_FACILITA_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_FACILITA);
            let facilita = action.data.items.map(u => new BackofficeUser(u));
            return { ...state, allDossiers: { ...state.allDossiers, facilita: facilita, totalFacilita: action.data.totalRecords } };

        case PartnerActionTypes.FETCH_FACILITA_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_FACILITA);
            return { ...state };

        case PartnerActionTypes.CREATE_USER_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.CREATING_USER)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.CREATING_USER);
            }
            return { ...state };

        case PartnerActionTypes.CREATE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.CREATING_USER);
            return { ...state };

        case PartnerActionTypes.CREATE_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.CREATING_USER);
            state.users = [...state.users, new BackofficeUser(action.data)];
            if (action.data.createdByRepresentative) {
                state.allDossiers.facilita = R.isNil(state.allDossiers.facilita) ? [] : state.allDossiers.facilita;
                state.allDossiers = { ...state.allDossiers, facilita: [...state.allDossiers.facilita, new BackofficeUser(action.data)], totalFacilita: state.allDossiers.totalFacilita + 1 };
            } else {
                state.allDossiers.anticipa = R.isNil(state.allDossiers.anticipa) ? [] : state.allDossiers.anticipa;
                state.allDossiers = { ...state.allDossiers, anticipa: [...state.allDossiers.anticipa, new BackofficeUser(action.data)], totalAnticipa: state.allDossiers.totalAnticipa + 1 };
            }
            return { ...state };

        case ActionTypesAuth.RESET_PASSWORD_SUCCESS:
            state.resetPasswordPhoneNumber = true;
            toast.success(TextClient.emailPasswordRecoveredSucess, toastConf);
            return { ...state };

        case ActionTypesAuth.RESET_PASSWORD_FAILURE:
            state.resetPasswordPhoneNumber = false;
            toast.error(TextClient.emailPasswordRecoveredFailed, toastConf);
            return { ...state };

        case ActionTypesClient.UPDATE_CLIENT_SECURITY_REQUEST:
            if (!state.isLoading.includes(LoadingsUser.UPDATE_SECURITY)) {
                state.isLoading = state.isLoading.concat(LoadingsUser.UPDATE_SECURITY);
            }
            return { ...state };

        case ActionTypesClient.UPDATE_CLIENT_SECURITY_SUCCESS:
            if (!R.isNil(action.user.newPhoneNumber)) {
                //state.user.phoneNumber = action.user.newPhoneNumber;
                // sessionStorage.removeItem("access_token");
                // window.location = "/auth/signin";
                state.users = state.users.map((user) => {
                    if (user.id === action.userId) {
                        user.phoneNumber = action.user.newPhoneNumber;
                        return user;
                    }
                    return user;
                });

            }
            if (!R.isNil(action.user.newEmail)) {
                state.users = state.users.map((user) => {
                    if (user.id === action.userId) {
                        user.email = action.user.newEmail;
                        return user;
                    }
                    return user;
                });

            }

            state.isLoading = state.isLoading.filter(c => c !== LoadingsUser.UPDATE_SECURITY);
            toast.success(TextUser.updateSecuritySuccess, toastConf);
            return { ...state };

        case ActionTypesClient.UPDATE_CLIENT_SECURITY_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== LoadingsUser.UPDATE_SECURITY);
            toast.error(TextUser.udpateSecurityFailed, toastConf);
            return { ...state };

        case ActionTypesUser.UPDATE_BACKOFFICE_USER_REQUEST:
            if (!state.isLoading.includes(LoadingsUser.UPDATE_USER)) {
                state.isLoading = state.isLoading.concat(LoadingsUser.UPDATE_USER);
            }
            return { ...state };

        case ActionTypesUser.UPDATE_BACKOFFICE_USER_SUCCESS:
            state.user = { ...state.user, isEnabled: false };

            state.isLoading = state.isLoading.filter(l => l !== LoadingsUser.UPDATE_USER);
            toast.success(TextUser.dataUpdatedSuccess, toastConf);
            return { ...state };

        case ActionTypesUser.UPDATE_BACKOFFICE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== LoadingsUser.UPDATE_USER);
            toast.error(TextUser.dataUpdateFailed, toastConf);
            return { ...state };

        case PartnerActionTypes.PAY_USER_INVOICE_REQUEST:
            // if (!state.isLoading.includes(LoadingsUser.UPDATE_USER)) {
            //     state.isLoading = state.isLoading.concat(LoadingsUser.UPDATE_USER);
            // }
            return { ...state };

        case PartnerActionTypes.PAY_USER_INVOICE_SUCCESS: {
            const markInvoiceAsPaid = (collection) => {
                if (R.isNil(collection)) {
                    return collection;
                }

                return collection.map((user) => {
                    if (user.pendingInvoiceId === action.invoiceId) {
                        return { ...user, hasPendingInvoice: false, pendingInvoiceId: null };
                    }

                    return user;
                });
            };

            state.users = markInvoiceAsPaid(state.users);
            state.allDossiers = {
                ...state.allDossiers,
                anticipa: markInvoiceAsPaid(state.allDossiers.anticipa),
                facilita: markInvoiceAsPaid(state.allDossiers.facilita),
                serenita: markInvoiceAsPaid(state.allDossiers.serenita)
            };

            toast.success(TextUser.invoicePaidSuccess, toastConf);
            return { ...state };
        }

        case PartnerActionTypes.PAY_USER_INVOICE_FAILURE:
            // state.isLoading = state.isLoading.filter(l => l !== LoadingsUser.UPDATE_USER);
            toast.error(TextUser.invoicePaidFailed, toastConf);
            return { ...state };



        default:
            return state;
    }
};
export default PartnerReducer;